export enum PAGE_ENUM {
  OVERVIEW = 'overview',
  SETTINGS = 'settings',
  SUBSCRIPTION = 'subscription',
  MARKETS = 'markets',
}

export enum TrackingStyle {
  CHANNEL_BASED = 'CHANNEL_BASED',
  URL_BASED = 'URL_BASED',
  HYBRID = 'HYBRID',
}

export enum MonitoringSource {
  PRISYNC_ENGINE = 'PRISYNC_ENGINE',
  DATAEDIS = 'DATAEDIS',
  HYBRID = 'HYBRID',
}
